
export default {
  auth: false,
  middleware: 'guest',
  data() {
    return {
      verified: false,
      message: 'We zijn bezig met het activeren van je account...',
    };
  },
  async mounted() {
    try {
      await this.$axios.post(
        `register/verify?token=${this.$route.query.token}`,
      );
      this.message =
        'Je account is geactiveerd! Je wordt over enkele ogenblikken doorgestuurd naar de login pagina.';
      const that = this;
      setTimeout(function () {
        that.$router.push(this.localePath({name: 'auth-inloggen'}));
      }, 3000);
    } catch (e) {
      // console.error(e);
      this.message =
        'Er is iets fout gegaan tijdens het activeren van je account. Probeer het later nog eens.';
    }
  },
};
